import "../create-admins/createAdmins.css";
import "../batch/batch.css";
import { useState } from "react";
import axiosInstance from "../../../api/axios";

const AssignApps = () => {
  const [acceptanceList, setAcceptanceList] = useState("");
  const [emails, setEmails] = useState([]);
  const [approvedEmails, setApprovedEmails] = useState([]);
  const [deniedEmails, setDeniedEmails] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [member, setMember] = useState("");

  const handleAcceptances = (event) => {
    const input = event.target.value;
    setAcceptanceList(input);

    const EMAIL_REGEX = /[\w.-]+@[\w.-]+\.[A-Za-z]{2,}/g;
    const emailArray = input.match(EMAIL_REGEX) || [];
    setEmails(emailArray);
  };

  const handleSubmitAcceptances = async (event) => {
    event.preventDefault();
    setApprovedEmails([]);
    setDeniedEmails([]);

    for (const email of emails) {
      try {
        const response = await axiosInstance.post(
          `/api/applications/assign-application/${member}/${email}`
        );

        setApprovedEmails((prevEmails) => [...prevEmails, email]);
      } catch (err) {
        // console.log(err);
        setDeniedEmails((prevEmails) => [...prevEmails, email]);
      }
    }

    setFormSubmitted(true);
    setAcceptanceList("");
    setEmails([]);
  };

  return (
    <div>
      <div className="dashboard">
        <h1 className="header-title-batch">Assign Applications for Review</h1>
        <div className="searches-ad">
          <br />
          <form onSubmit={handleSubmitAcceptances}>
            <div>
              <label>Member:</label>
              <input
                value={member}
                onChange={(e) => setMember(e.target.value)}
                className="batch-select-options"
              />
            </div>

            <p>
              Submit a list of emails to assign to the member above for review.
            </p>
            <textarea
              className="acceptances-input"
              name="email"
              placeholder="List emails here..."
              value={acceptanceList}
              onChange={handleAcceptances}
            />

            <br />
            <button className="button-batch" type="submit">
              Submit
            </button>
          </form>
        </div>

        {formSubmitted && (
          <div className="accepted-or-failed-div">
            <div className="accepted-div">
              <h1 className="acceptances-emails">Approved</h1>
              <ul>
                {approvedEmails.map((email, index) => (
                  <li className="accept" key={index}>
                    {email}
                  </li>
                ))}
              </ul>
            </div>
            <div className="accepted-div">
              <h1 className="acceptances-emails">Failed</h1>
              <ul>
                {deniedEmails.map((email, index) => (
                  <li className="accept" key={index}>
                    {email}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignApps;
